import { BlockGenerationData } from './blockGenerationService';

export const exportService = {
  exportToCSV(data: BlockGenerationData, filename: string = 'block_generation_data.csv') {
    // Convert data to CSV format
    const dates = Object.keys(data).sort();
    const blocks = new Set<string>();
    
    // Get all unique block IDs
    Object.values(data).forEach(dayData => {
      Object.keys(dayData).forEach(blockId => blocks.add(blockId));
    });
    
    const blockIds = Array.from(blocks).sort();
    
    // Create CSV header
    const header = ['Date', ...blockIds.map(id => `${id}_Generation_kWh`), ...blockIds.map(id => `${id}_CUF_%`), ...blockIds.map(id => `${id}_Flatline`)];
    
    // Create CSV rows
    const rows = dates.map(date => {
      const row = [date];
      
      // Add generation values
      blockIds.forEach(blockId => {
        const blockData = data[date][blockId];
        row.push(blockData ? blockData.generation_kwh.toString() : '0');
      });
      
      // Add CUF values
      blockIds.forEach(blockId => {
        const blockData = data[date][blockId];
        row.push(blockData ? blockData.cuf.toString() : '0');
      });
      
      // Add flatline status
      blockIds.forEach(blockId => {
        const blockData = data[date][blockId];
        row.push(blockData ? (blockData.is_flatline ? 'TRUE' : 'FALSE') : 'FALSE');
      });
      
      return row;
    });
    
    // Combine header and rows
    const csvContent = [header, ...rows]
      .map(row => row.map(field => `"${field}"`).join(','))
      .join('\n');
    
    // Download CSV
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },

  exportToPNG(elementId: string, filename: string = 'block_generation_chart.png') {
    // This would require html2canvas library for implementation
    // For now, just show a message
    console.log(`PNG export functionality would capture element ${elementId} and save as ${filename}`);
    alert('PNG export functionality requires html2canvas library. Please install it for full functionality.');
  }
};